import styled from 'styled-components'

export const Container = styled.div`
border-radius: 0.938rem;
width: 100%;
border: 0.188rem solid var(--c3);
box-sizing: border-box;
padding: 1.5rem;
`
